<div class="dialog-header">
  <div class="header-left">
    <div class="entity-icon">
      <mat-icon>{{ entityIcon }}</mat-icon>
    </div>
    <div>
      <h2 mat-dialog-title>Détail de l'audit</h2>
      <span class="entity-type">{{ data.audit.entityType }}</span>
    </div>
  </div>
  <span class="op-badge" [ngClass]="'op-' + data.audit.operation.toLowerCase()">
    {{ operationLabel }}
  </span>
</div>

<mat-dialog-content>

  <div class="meta-grid">
    <div class="meta-item">
      <mat-icon class="meta-icon">person</mat-icon>
      <div>
        <span class="meta-label">Par</span>
        <span class="meta-value">
          {{ data.audit.actorDisplayName || data.audit.actorIdentifier || 'Inconnu' }}
        </span>
      </div>
    </div>
    <div class="meta-item" *ngIf="data.audit.actorRole">
      <mat-icon class="meta-icon">shield</mat-icon>
      <div>
        <span class="meta-label">Rôle</span>
        <span class="meta-value">{{ data.audit.actorRole }}</span>
      </div>
    </div>
    <div class="meta-item">
      <mat-icon class="meta-icon">schedule</mat-icon>
      <div>
        <span class="meta-label">Date</span>
        <span class="meta-value">{{ data.audit.createdAt | date:"dd/MM/yyyy 'à' HH:mm" }}</span>
      </div>
    </div>
    <div class="meta-item" *ngIf="data.audit.projet">
      <mat-icon class="meta-icon">folder</mat-icon>
      <div>
        <span class="meta-label">Projet</span>
        <span class="meta-value">{{ data.audit.projet }}</span>
      </div>
    </div>
  </div>

  <div class="no-changes" *ngIf="changes.length === 0">
    <mat-icon>info</mat-icon>
    Aucun changement de champ enregistré pour cet événement.
  </div>

  <div class="changes-section" *ngIf="changes.length > 0">
    <div class="changes-header">
      <mat-icon>swap_horiz</mat-icon>
      <span>Champs modifiés ({{ changes.length }})</span>
    </div>

    <div class="changes-table-wrap">
      <div class="changes-table-head">
        <span>Champ</span>
        <span>Avant</span>
        <span></span>
        <span>Après</span>
      </div>
      <div class="changes-row"
           *ngFor="let c of changes; let last = last"
           [class.last]="last">
        <span class="field-name">{{ c.label }}</span>
        <span class="val-before">{{ c.before }}</span>
        <mat-icon class="arrow-icon">arrow_forward</mat-icon>
        <span class="val-after">{{ c.after }}</span>
      </div>
    </div>
  </div>

</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Fermer</button>
</mat-dialog-actions>